import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

import { Environment } from 'src/environments/environment.model';

import { AgroConnectCustomer, AgroConnectExternalParty } from '../models';

@Injectable({
  providedIn: 'root',
})
export class AgroConnectService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  getExternalCustomers(
    externalParty: AgroConnectExternalParty,
    cropYear: number,
  ): Observable<AgroConnectCustomer[]> {
    return this.http.get<AgroConnectCustomer[]>(
      `${this.baseUrl}/customers/${externalParty}/${cropYear}`,
    );
  }

  private get baseUrl(): string {
    return this.env.ROUTE_FMS_CUSTOMERS_THROUGH_INTEGRATION
      ? `${this.env.APIM_BASE_URL}/arable-integration-service/integrations/fms`
      : `${this.env.API_BASE_URL}/service/agro-connect-crop-field/secure/agroconnectcropfield`;
  }
}
